import { render, staticRenderFns } from "./StockTable.vue?vue&type=template&id=25c21b51&scoped=true&"
import script from "./StockTable.vue?vue&type=script&lang=ts&"
export * from "./StockTable.vue?vue&type=script&lang=ts&"
import style0 from "./StockTable.vue?vue&type=style&index=0&id=25c21b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c21b51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField,VTooltip})
